import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

export const ForeignFlightProposalInstruction = () => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <div style={styles.instructionBox}>
      <div style={styles.instructionHeader}>
        <span style={styles.instructionIcon}>📝</span>
        <span style={styles.instructionTitle}>選択方法</span>
      </div>
      <ul style={styles.instructionList}>
        <li>
          往路は復路とペアになる候補のみ表示されます。往路を選ぶと往路が固定され、続けて復路の候補が別のメッセージで表示されます。
        </li>
        <li>
          各カードの上段は「往路」「復路」それぞれの候補について、往復合計料金の幅（最安〜最高）です。金額はブレがない場合は1件だけ表示されます。
        </li>
        <li>表の「料金（往復）」列も、往路と復路を含む同一セットの合計です。</li>
        <li>「詳細・条件」は長文になりやすいため、まずは「詳細を開く」で折りたたみを開いて全文を確認できます。</li>
        <li>往路・復路を選ぶと往復のフライトと料金が確定します。その後、ホテルなどの候補が表示されます。</li>
        <li>各商品の「選択」ボタンをクリックしてください。選択状況は右側のパネルで確認できます。</li>
      </ul>
      <p style={styles.instructionNote}>※不要な商品がある場合、カード右上の「×」を押してください。</p>
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  instructionBox: {
    backgroundColor: '#e6f4fb',
    borderLeft: `4px solid ${theme.linkColor}`,
    borderRadius: '4px',
    padding: '14px',
    marginTop: '16px'
  },
  instructionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '6px'
  },
  instructionIcon: {
    fontSize: '14px'
  },
  instructionTitle: {
    fontSize: '13px',
    fontWeight: 600 as const,
    color: theme.linkColor
  },
  instructionList: {
    margin: '0 0 8px 0',
    fontSize: '12px',
    color: theme.grayTextColor,
    lineHeight: 1.6
  },
  instructionNote: {
    margin: 0,
    fontSize: '11px',
    color: theme.grayTextColor
  }
});
